module.exports = __webpack_public_path__ + "img/icon_home_yw07.09eb7a7b.png";